<div [class.container--narrow]="width === 'narrow'" [class.container--wide]="width === 'wide'" class="container">
  <ng-content></ng-content>
</div>
